import styled from "styled-components";
import { ChevronLeft, ChevronRight } from "@styled-icons/boxicons-regular";
import { motion } from "framer-motion";

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  .next,
  .prev {
    top: calc(50% - 20px);
    position: absolute;
    background: white;
    border-radius: 30px;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    cursor: pointer;
    font-weight: bold;
    font-size: 18px;
    z-index: 2;
  }

  .next {
    right: 10px;
  }

  .prev {
    left: 10px;
    transform: scale(-1);
  }
`;

export const Slide = styled(motion.div)`
  position: absolute;
  width: 100vw;
  height: 100vh;
`;

export const IconLeft = styled(ChevronLeft).attrs({ size: 64 })`
  color: white;
`;

export const IconRight = styled(ChevronRight).attrs({ size: 64 })`
  color: white;
`;

export const ButtonPrev = styled.button.attrs({ type: "button" })`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  position: absolute;
  left: 0;
  top: center;
  z-index: 99;

  &.slick-disabled {
    opacity: 0.5;
  }
`;

export const ButtonNext = styled.button.attrs({ type: "button" })`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  position: absolute;
  right: 0;
  top: center;
  z-index: 99;

  &.slick-disabled {
    opacity: 0.5;
  }
`;
